import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { confirmEmailFunctionURL } from "../../Constants";
import "./EmailConfirmation.scss";

interface EmailConfirmationProps {
    tokenID: string;
    email: string;
}

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const EmailConfirmation: React.FC<EmailConfirmationProps> = ({ tokenID, email }) => {
    const navigate = useNavigate();
    const [status, setStatus] = useState<"loading" | "confirmed" | "error" | "alreadyConfirmed">("loading");
    const [errorMessage, setErrorMessage] = useState("");

    const hasRun = useRef(false);

    useEffect(() => {
        // Prevent double execution of effect
        if (hasRun.current) return;
        hasRun.current = true;

        const confirmEmail = async () => {
            setStatus("loading");
            const decodedEmail = decodeURIComponent(email);

            if (!EMAIL_REGEX.test(decodedEmail)) {
                setStatus("error");
                setErrorMessage("Es ist ein Fehler aufgetreten. Bitte überprüfen Sie die Bestätigungs-E-Mail noch einmal");
                return;
            }

            try {
                const response = await axios.post(
                    confirmEmailFunctionURL!,
                    {
                        tokenID: tokenID,
                        email: decodedEmail
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                );

                if (response.status === 200) {
                    const message = response.data?.message || "";
                    if (message.includes("bereits bestätigt")) {
                        setStatus("alreadyConfirmed");
                        setTimeout(() => navigate(`/${tokenID}`), 2000);
                    } else {
                        setStatus("confirmed");
                        setTimeout(() => navigate(`/${tokenID}`), 2000);
                    }
                }
            } catch (error: any) {
                setStatus("error");
                setErrorMessage(error.response?.data?.message ||
                    `Fehler beim Bestätigen der Email. ${error.response?.data}`);
                console.error("Confirmation error:", error);
            }
        };

        confirmEmail();
    }, [tokenID, navigate, email]);

    return (
        <div className="email-confirmation">
            {status === "loading" && (
                <div className="confirmation-message">
                    <p>Bestätigung wird durchgeführt...</p>
                </div>
            )}

            {status === "confirmed" && (
                <div className="confirmation-message success">
                    <p>Email erfolgreich bestätigt! Weiterleitung zum Formular...</p>
                </div>
            )}

            {status === "alreadyConfirmed" && (
                <div className="confirmation-message info">
                    <p>Ihre E-Mail-Adresse wurde bereits bestätigt. Weiterleitung zum Formular...</p>
                </div>
            )}

            {status === "error" && (
                <div className="confirmation-message error">
                    <p>{errorMessage}</p>
                </div>
            )}
        </div>
    );
};

export default EmailConfirmation;